import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from '~/components';

interface SelectTransferCategoryProps {
  onChange: (e: any) => void;
  value: string;
  name?: string;
  label?: string;
  [x: string]: any;
}

export const SelectTransferCategory = (props: SelectTransferCategoryProps) => {
  const { onChange, value, name, label, ...rest } = props;
  const translate = useTranslate();
  const t = (key: string) => translate(`resources.transfers.transferCategories.${key}`);
  return (
    <SelectInput
      label={label || t('_')}
      options={[
        { value: '', text: t('any') },
        { value: 'TRANSACTION', text: t('TRANSACTION') },
        { value: 'PRINCIPAL', text: t('PRINCIPAL') },
        { value: 'INTEREST', text: t('INTEREST') },
        { value: 'PENALTY', text: t('PENALTY') },
        { value: 'FEE', text: t('FEE') },
        { value: 'TAX', text: t('TAX') },
        { value: 'LOYALTY', text: t('LOYALTY') },
        { value: 'INSURANCE', text: t('INSURANCE') },
        { value: 'SAVINGS', text: t('SAVINGS') },
        { value: 'ACQUIRING_FEE', text: t('ACQUIRING_FEE') },
        { value: 'CASH_ACQUIRING_FEE', text: t('CASH_ACQUIRING_FEE') },
      ]}
      onChange={onChange}
      value={value || ''}
      name={name || 'transferCategory'}
      {...rest}
    />
  );
};
